/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Highlight_Settings_Highlight_DescriptionInputs */

const en_highlight_settings_highlight_description = /** @type {(inputs: Highlight_Settings_Highlight_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose how the current text is highlighted`)
};

const es_highlight_settings_highlight_description = /** @type {(inputs: Highlight_Settings_Highlight_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elige cómo se resalta el texto actual`)
};

/**
* | output |
* | --- |
* | "Choose how the current text is highlighted" |
*
* @param {Highlight_Settings_Highlight_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const highlight_settings_highlight_description = /** @type {((inputs?: Highlight_Settings_Highlight_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Highlight_Settings_Highlight_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_highlight_settings_highlight_description(inputs)
	return en_highlight_settings_highlight_description(inputs)
});